import { useResolvedLang } from '../../utils/resolveLang';
import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

import Section from '../shared/Section';
import Slider from '../shared/Slider';
import { Linkedin } from 'react-feather';
import TeamCard from './../team/TeamCard';
import { TeamData, TeamDataRoot } from './../team/types/TeamData';

import Testimonials from '../shared/testimonial/Testimonials';

import './society.css';
import './../team/teamcard.css';
import ImageLoader from '../shared/loader/ImageLoader';

const Society = (): React.JSX.Element => {
    const urlLang = useResolvedLang();

    const { t } = useTranslation();
    const [langue, setlangue] = React.useState<string | null>(null);
    const [loading, setLoading] = React.useState(false);
    const [teamData, setTeamData] = useState<TeamData[]>();
    const loaders = Array(12).fill(0);
    const teamUrl = "/api/team/team.json";
    const partnerUrl = "/api/partner/partner.json";
    useEffect(() => {
        const preferredLang = urlLang;
        setlangue(preferredLang);
    }, [urlLang])
    useEffect(() => {
        if (!langue) return;
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(teamUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data: TeamDataRoot = await response.json();
                
                if (langue === "fr") {
                    setTeamData(data.data_fr);

                }
                if (langue === "en") {
                    setTeamData(data.data_en);

                }
                if (langue === "es") {
                    setTeamData(data.data_es);
                }
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            } catch (err) { }
        };

        fetchData();
    }, [langue]);

    //const [partnerData, setPartnerData] = useState<PartnerData[]>();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(partnerUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                //const data: PartnerDataRoot = await response.json();
                //setPartnerData(data.data);
            } catch (err) { }
        };

        fetchData();
    }, []);

    return <>
    <Section className="section-society top-section">
            <Row className='section-society py4'>
                <Col lg={0} >
                    <div className="smedia-sidebar">
                        <div className="smedia-content">
                            <a href="https://www.linkedin.com/company/flowly1/" target="_blank" rel="noreferrer">
                                <span className="smedia-sidebar"><Linkedin size="18" /></span>
                                <span className="smedia-divider"></span>
                                <span className="smedia-text">{t("NavBar.FollowUs")}</span>
                            </a>
                        </div>
                    </div>
                </Col>
                <Col lg={8}  xs={12}>
                        <h2 dangerouslySetInnerHTML={
                            { __html: t('Pages.Society.Title')! }
                        } />

                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Society.Declaration')! }
                    } />
                </Col>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
            </Row>
    </Section>
        <Section className="section-society-team" dataTrackContent={true} dataContentName='society-team'>
        <Row >
            <Col xs={12}>
                <h3 dangerouslySetInnerHTML={
                    { __html: t('Pages.Society.Team')! }
                } />
            </Col>
        </Row>
    </Section>
        <Section className="section-team-card">
            {
            <Row>
                {
                    loading && loaders.map((el, index) =>
                        <Col key={index} xs={12} sm={12} md={6} lg={4} xl={4} xxl={3} className="text-center mt-4" style={{ height: "300px" }}>
                            <ImageLoader />
                        </Col>
                    )
                }
                {
                    !loading && teamData?.map((group, grIndex) => (
                        <React.Fragment key={grIndex}>
                        {
                            group.data.map((team, index) =>
                                <Col key={index} xs={12} sm={12} md={6} lg={4} xl={4} xxl={3} className={`text-center mt-4 ${!team.active ? 'd-none' : ''}`} >
                                    <TeamCard job={team.job} lastname={team.lastname} firstname={team.firstname} description={team.description} link={team.link} category={team.category} img={team.img} active={team.active} />
                                </Col>
                            )
                        }
                    </React.Fragment>))
                }
            </Row>
        }
    </Section>
        <Section className="section-society society-content" dataTrackContent={true} dataContentName='society-partners'>
        <Row>
            <Col xs={12} className="text-center mt-4">
                    <h4 dangerouslySetInnerHTML={
                        { __html: t('Pages.Society.Partenaires') === undefined ? "" : t('Pages.Society.Partenaires') }
                    } />
            </Col>
            <Col xs={12} className="text-center mt-4">
                    <Row xs={12} className="text-center">
                        <Slider />
                    </Row>
            </Col>
        </Row>
    </Section>
        <Section className="section-society-comment" dataTrackContent={true} dataContentName='society-comments'>
        <Row >
            <Col xs={12} className="text-center">
                <h4 dangerouslySetInnerHTML={
                    { __html: t('Pages.Home.Testimonial')! }
                } />
            </Col>
            <Col xs={12} className="text-center">
                <Testimonials />
            </Col>
        </Row>
    </Section>
    </>
};

export default Society;